import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-6 text-center">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute select-none font-heading text-[10rem] font-black leading-none text-background-100 md:text-[16rem]"
      >
        404
      </span>

      <div className="relative z-10 flex w-full max-w-md flex-col items-center">
        <span className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          We couldn't find that page
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          The link may be broken, or the page may have been moved. Let's get you back on track.
        </p>
        <p className="mt-2 max-w-full truncate rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>

        <div className="mt-7 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/"
            className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-home-4-line text-base" /> Back to home
          </Link>
          <Link
            to="/directory"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 sm:w-auto"
          >
            <i className="ri-search-line text-base" /> Browse the directory
          </Link>
        </div>
      </div>
    </div>
  );
}